import { Component } from "react";
import Dispatcher from "../../../api/Dispatcher";
import "./LoadingOverlay.less";

// Full-screen spinner shown while user-instigated backend requests are pending.
// Loading state is broadcast from the axios interceptors in UserService.js via
// the "loading:change" event (background/poller calls opt out with skipLoading).
class LoadingOverlay extends Component {
    state = { loading: false };

    handleLoadingChange = (loading) => {
        this.setState({ loading: !!loading });
    };

    componentDidMount() {
        Dispatcher.on("loading:change", this.handleLoadingChange);
    }

    componentWillUnmount() {
        Dispatcher.off("loading:change", this.handleLoadingChange);
    }

    render() {
        if (!this.state.loading) return null;

        return (
            <div className="loading-overlay" role="status" aria-live="polite" aria-busy="true">
                <div className="loading-overlay__spinner" />
            </div>
        );
    }
}

export default LoadingOverlay;
